export const deviceTable = function () {
  return {
    page: true,
    index: true,
    indexLabel: "序号",
    maxHeight: "100%",
    column: [
      {
        label: "设备名称",
        prop: "deviceName",
        search: true,
        clearable: true
      },
      {
        label: "设备ID",
        prop: "deviceId",
      },
      {
        label: "设备类型",
        prop: "deviceTypeName",
      },
      {
        label: "设备状态",
        prop: "status",
        formatter: function (row, value) {
          if (Number(value) === 1) {
            return "在线";
          } else if (Number(value) === 0) {
            return "离线";
          }
          return "";
        }
      },
    ]
  };
};
